'use client'

import { useState } from 'react'
import { Input } from '@/components/ui/input'
import { Textarea } from '@/components/ui/textarea'
import { Label } from '@/components/ui/label'
import { toast } from 'sonner'
import { LandingButton } from '@/components/landing/landing-button'

export function ContactForm() {
    const [isSubmitting, setIsSubmitting] = useState(false)
    const [formData, setFormData] = useState({
        name: '',
        email: '',
        subject: '',
        message: '',
    })

    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault()
        setIsSubmitting(true)

        try {
            // TODO: Implement actual form submission logic
            // For now, just simulate a submission
            await new Promise((resolve) => setTimeout(resolve, 1000))

            toast.success('Message sent successfully!', {
                description: "We'll get back to you as soon as possible.",
            })

            // Reset form
            setFormData({
                name: '',
                email: '',
                subject: '',
                message: '',
            })
        } catch {
            toast.error('Failed to send message', {
                description: 'Please try again later or email us directly.',
            })
        } finally {
            setIsSubmitting(false)
        }
    }

    const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
        setFormData((prev) => ({
            ...prev,
            [e.target.name]: e.target.value,
        }))
    }

    return (
        <form onSubmit={handleSubmit} className="space-y-5 flex flex-col">
            <div className="space-y-2">
                <Label htmlFor="name" className="text-black-40 text-[12px] font-medium">
                    Name *
                </Label>
                <Input
                    id="name"
                    name="name"
                    type="text"
                    placeholder="Your name"
                    required
                    value={formData.name}
                    onChange={handleChange}
                    disabled={isSubmitting}
                    className="bg-black-3 border-black-6"
                />
            </div>

            <div className="space-y-2">
                <Label htmlFor="email" className="text-black-40 text-[12px] font-medium">
                    Email *
                </Label>
                <Input
                    id="email"
                    name="email"
                    type="email"
                    placeholder="your@email.com"
                    required
                    value={formData.email}
                    onChange={handleChange}
                    disabled={isSubmitting}
                    className="bg-black-3 border-black-6"
                />
            </div>

            <div className="space-y-2">
                <Label htmlFor="subject" className="text-black-40 text-[12px] font-medium">
                    Subject *
                </Label>
                <Input
                    id="subject"
                    name="subject"
                    type="text"
                    placeholder="What is this regarding?"
                    required
                    value={formData.subject}
                    onChange={handleChange}
                    disabled={isSubmitting}
                    className="bg-black-3 border-black-6"
                />
            </div>

            <div className="space-y-2">
                <Label htmlFor="message" className="text-black-40 text-[12px] font-medium">
                    Message *
                </Label>
                <Textarea
                    id="message"
                    name="message"
                    placeholder="Tell us more about your inquiry..."
                    required
                    rows={6}
                    value={formData.message}
                    onChange={handleChange}
                    disabled={isSubmitting}
                    className="resize-none bg-black-3 border-black-6"
                />
            </div>

            <LandingButton
                type="submit"
                variant="blue"
                disabled={isSubmitting}
                className="self-end"
            >
                {isSubmitting ? 'Sending...' : 'Send'}
            </LandingButton>
        </form>
    )
}
